// extracted by mini-css-extract-plugin
export default {"display_mode":"DisplayMode_display_mode__xpXcY","display_mode__container":"DisplayMode_display_mode__container__uv+qw"};